import { Badge, Box, Switch, Tbody, Td, Tr } from '@ff-it/ui';
import { type EntityContextType } from 'components';
import type { BlockDetails, BlockState } from 'modules/campaign/block/types';
import { type ReactElement, useState } from 'react';
import { Block } from './Block';
import { CampaignDetails } from '../types';
import { BlockStateTag } from 'modules/campaign/status/BlockStateTag';

type StateGroupProps = {
  state: BlockState;
  blocks: BlockDetails[];
  collapse?: boolean;
  campaign: CampaignDetails;
  toggleLoading: (loading: boolean) => void;
  replace: (block: BlockDetails) => void;
  remove: (block: BlockDetails) => void;
  add: (block: BlockDetails) => void;
};

export function BlockGroup({
  state,
  blocks,
  collapse,
  toggleLoading: setLoading,
  replace: setItem,
  campaign,
  remove,
  add,
}: StateGroupProps): ReactElement {
  const [show, setShow] = useState(!collapse);

  return (
    <Tbody>
      <Tr>
        <Td colSpan={12}>
          <Box display="flex" alignItems="center">
            {collapse ? (
              <Box display="flex" alignItems="center">
                <Switch
                  checked={show}
                  data-testid="toggle-show-group"
                  data-block-state={state}
                  id="toggle-show-group"
                  onChange={() => setShow((c) => !c)}
                  size="sm"
                />
                <Box as="label" htmlFor="toggle-show-group" mb="0" ml="2" fontSize="sm" userSelect="none">
                  <Badge count={blocks.length} variant="secondary">
                    <BlockStateTag state={state} appearance="outline" />
                  </Badge>
                </Box>
              </Box>
            ) : (
              <BlockStateTag state={state} appearance="outline" />
            )}
          </Box>
        </Td>
      </Tr>
      {show &&
        blocks.map((block) => {
          const itemContext = {
            item: block,
            setSpinning: setLoading,
            setItem,
            endpoint: `campaign/blocks/${block.id}/`,
          } as EntityContextType<BlockDetails>;
          return <Block key={block.id} campaign={campaign} itemContext={itemContext} remove={remove} add={add} />;
        })}
    </Tbody>
  );
}
